import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ClassAndDivService from "services/ClassAndDivService";

export const getClassAndDiv = createAsyncThunk(
  "classes/getClassAndDiv",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ClassAndDivService.getClassAndDivision(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch class and division"
      );
    }
  }
);
export const searchClasses = createAsyncThunk(
  "classes/searchClasses",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ClassAndDivService.getClassAndDivision(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch class and division"
      );
    }
  }
);
export const downloadClassDivisionExcel = createAsyncThunk(
  "user/downloadUserExcel",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await ClassAndDivService.downalodClassAndDivisionExcel(
        data,
        params
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getClassDivision = createAsyncThunk(
  "classes/getClassDivision",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ClassAndDivService.getClassAndDivision(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch class and division"
      );
    }
  }
);

export const statusUpdateClassAndDiv = createAsyncThunk(
  "classes/statusUpdateClassAndDiv",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ClassAndDivService.statusUpdateClassAndDivision(
        data
      );

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to Update Status"
      );
    }
  }
);

export const addClassAndDiv = createAsyncThunk(
  "classes/addClassAndDiv",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ClassAndDivService.addClassAndDivision(data);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add Class"
      );
    }
  }
);

export const statusUpdateDivision = createAsyncThunk(
  "classes/statusUpdateDivision",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ClassAndDivService.statusUpdateDivision(data);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to Update Status"
      );
    }
  }
);

export const updateClassAndDivision = createAsyncThunk(
  "classes/updateClassAndDivision",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await ClassAndDivService.updateClassAndDivision(
        id,
        data
      );
      return response;
    } catch (err) {
      console.error("Update error:", err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to update class and division"
      );
    }
  }
);

export const getSingleClass = createAsyncThunk(
  "classes/getSingleClass",
  async (class_id, { rejectWithValue }) => {
    try {
      const response = await ClassAndDivService.getSingleClass(class_id);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch class and division"
      );
    }
  }
);

// export const removeDivision = createAsyncThunk(
//   "classes/removeDivision",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await ClassAndDivService.removeDivision(id);
//       return response;
//     } catch (err) {
//       return rejectWithValue(
//         err.response?.data?.message || "Failed to delete division"
//       );
//     }
//   }
// );

export const addDivision = createAsyncThunk(
  "classes/addDivision",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ClassAndDivService.addDivision(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to Add division"
      );
    }
  }
);

export const updateDivision = createAsyncThunk(
  "classes/updateDivision",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ClassAndDivService.updateDivision(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update division"
      );
    }
  }
);

export const updateBulkClassStatus = createAsyncThunk(
  "school/updateBulkClassStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const data = payload?.data;
      const status = payload?.status;
      const response = await ClassAndDivService.updateBulkClassStatus({
        data,
        status,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "Failed to update status");
    }
  }
);

const classanddivSlice = createSlice({
  name: "classes",
  initialState: {
    classes: {},
    singleClass: null,
    loading: false,
    error: null,
    division: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClassAndDiv.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getClassAndDiv.fulfilled, (state, action) => {
        state.loading = false;
        state.classes = action.payload;
      })
      .addCase(getClassAndDiv.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(downloadClassDivisionExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadClassDivisionExcel.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(downloadClassDivisionExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getClassDivision.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getClassDivision.fulfilled, (state, action) => {
        state.loading = false;
        state.division = action.payload;
      })
      .addCase(getClassDivision.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //status update
      .addCase(statusUpdateClassAndDiv.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(statusUpdateClassAndDiv.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(statusUpdateClassAndDiv.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //add class
      .addCase(addClassAndDiv.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addClassAndDiv.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addClassAndDiv.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // division status update
      .addCase(statusUpdateDivision.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(statusUpdateDivision.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(statusUpdateDivision.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // update class and division
      .addCase(updateClassAndDivision.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClassAndDivision.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateClassAndDivision.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Get Single Class
      .addCase(getSingleClass.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleClass.fulfilled, (state, action) => {
        state.loading = false;
        state.singleClass = action.payload;
      })
      .addCase(getSingleClass.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // add division
      .addCase(addDivision.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addDivision.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addDivision.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // update division
      .addCase(updateDivision.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDivision.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateDivision.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // remove division
      // .addCase(removeDivision.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(removeDivision.fulfilled, (state, action) => {
      //   state.loading = false;
      // })
      // .addCase(removeDivision.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })
      // bulk update status
      .addCase(updateBulkClassStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBulkClassStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateBulkClassStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {} = classanddivSlice.actions;
export default classanddivSlice.reducer;
